// removed by extract-text-webpack-plugin
module.exports = {"wrap":"YHHofabjw5-Bl7CSOLpj7","heading":"lwSM10zHGbLbov8GjUUoT"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionLogin.scss
// module id = 2649
// module chunks = 0